import { API } from "aws-amplify";
import { createPayment as createPaymentMut } from "../graphql/mutations";
import { GraphQLQuery } from "@aws-amplify/api";
import {
    CreatePaymentInput,
    CreatePaymentMutation,
    CreatePaymentResponse,
} from "../API";
import { useCallback } from "react";

export function useCreatePayment() {
    const createPayment = useCallback(
        async (
            input: CreatePaymentInput
        ): Promise<Partial<CreatePaymentResponse | null>> => {
            const result = await API.graphql<
                GraphQLQuery<CreatePaymentMutation>
            >({
                query: createPaymentMut,
                variables: { input },
            });

            return result.data?.createPayment || null;
        },
        []
    );

    return { createPayment };
}
